import BaseComponent from "@js/components/base_component.jsx";

class EuiTableOfReferences extends BaseComponent {

  render() {
    if (this.props.entities.length > 0) {
      return (
        <table className="table table-hover">
          <thead>
            <tr>
              <th width="25" />
              <th className="column-name">{I18n.t("headings.name")}</th>
              <th className="column-type">{I18n.t("headings.type")}</th>
              <th className="index-buttons column-actions">&nbsp;</th>
            </tr>
          </thead>
          <tbody>{this._renderEntityRows()}</tbody>
        </table>
      );
    } else if (this.props.emptyTableText) {
      return (
        <EmptyTableNotification
          size={ this.props.emptyTableTextSize }
          text={ I18n.t("empty_table." + this.props.emptyTableText) }
          offerNew={ false }
        />
      );
    } else {
      return (
        <EmptyTableNotification
          size={ this.props.emptyTableTextSize }
          type="Entities"
          offerNew={ false }
        />
      );
    }
  }

  _renderEntityRows() {
    return this.props.entities.map((entity, i) => {
      const path = this._resolveViewPath(entity);

      return (
        <tr key={i}>
          <td>
            <FaIcon name="chevron-circle-right" />
          </td>
          <td>{entity.name}</td>
          <td>{this._resolveTypeString(entity)}</td>
          <td className="index-buttons actions">
            {
              path && (
                <ButtonView href={ path } size="small" />
              )
            }
          </td>
        </tr>
      );
    });
  }

  _resolveTypeString(entity) {
    switch ( entity.entity_type ) {
    case "eng_config":
      return I18n.t("types." + entity.entity_type + "_" + this.props.type);
    default:
      return I18n.t("types." + entity.entity_type);
    }
  }

  _resolveViewPath(entity) {
    switch ( entity.entity_type ) {
    case "default_virtual_mta":
      return Routes.eui_virtual_mta_entities_path({
        anchor: "default_virtual_mta"
      });
    case "mail_class":
      return Routes.eui_mail_class_path(entity.id);
    case "sending_domain":
      return Routes.eui_sending_domain_path(entity.id);
    case "shared_tracking_domain":
      return Routes.eui_shared_tracking_domain_path(entity.id);
    case "engine_user":
      return Routes.eui_user_path(entity.id);
    case "ip_address":
    case "routing_rule":
    case "relay_server":
      return Routes[`eui_virtual_mta_${entity.entity_type}_path`]({
        id: entity.id
      });
    case "eng_config":
      switch ( this.props.type ) {
      case "url_domain":
        return Routes.eui_url_domains_path();
      default:
        return null;
      }
    default:
      return null;
    }
  }

}

export default EuiTableOfReferences;
